import type React from 'react';

import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

import type { Section } from '../../models';
import { FEE_PAYMENT_TIME } from '../../constants/stringConstants';
import { calculateMonthsBetweenEndAndStartDate, getStartDayOfTheLeaseLabel } from '../../constants/functionConstants';
import { LEASE_TERMS } from '../../constants';

type Props = {
  label: string;
  firstChecked: boolean;
  secondChecked: boolean;
  thirdChecked: boolean;
  fourthChecked: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (event: any) => void;
  section: Section;
  firstField?: string;
  secondField?: string;
  thirdField?: string;
  fourthField?: string;
};

export default function FeePaymentTime_v2({
  label,
  firstChecked,
  secondChecked,
  thirdChecked,
  fourthChecked,
  onChange,
  section,
  firstField,
  secondField,
  thirdField,
  fourthField,
}: Props) {
  const firstFieldDisabled = firstField ? section.isFieldDisabled(firstField) : false;
  const secondFieldDisabled = secondField ? section.isFieldDisabled(secondField) : false;
  const thirdFieldDisabled = firstField ? section.isFieldDisabled(thirdField) : false;
  const fourthFieldDisabled = secondField ? section.isFieldDisabled(fourthField) : false;

  return (
    <FieldSet
      legend={<Legend>{label}</Legend>}
      disabled={firstFieldDisabled && secondFieldDisabled && thirdFieldDisabled && fourthFieldDisabled}
    >
      <LabeledControl
        controlId={FEE_PAYMENT_TIME.FIRST_PAY_ON_SIGN}
        label={<Label>Upon signing the lease</Label>}
        control={<Radio name="fee-payment-timing" checked={firstChecked} onChange={onChange} />}
        disabled={firstFieldDisabled}
      />
      <LabeledControl
        controlId={FEE_PAYMENT_TIME.FIRST_PAY_ON_LEASE_START}
        label={<Label>{getStartDayOfTheLeaseLabel(section)}</Label>}
        control={<Radio name="fee-payment-timing" checked={secondChecked} onChange={onChange} />}
        disabled={secondFieldDisabled}
      />
      {(section.getFieldValue(LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH) ||
        (section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE) &&
          section.getFieldValue(LEASE_TERMS.FIELD_NAME.END_DATE) &&
          calculateMonthsBetweenEndAndStartDate(section) <= 2)) && (
        <LabeledControl
          controlId={FEE_PAYMENT_TIME.TWO_EQUAL_INSTALLMENTS}
          label={<Label>In two consecutive equal installments, beginning upon the lease start date</Label>}
          control={<Radio name="fee-payment-timing" checked={thirdChecked} onChange={onChange} />}
          disabled={thirdFieldDisabled}
        />
      )}
      {section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE) &&
        section.getFieldValue(LEASE_TERMS.FIELD_NAME.END_DATE) &&
        calculateMonthsBetweenEndAndStartDate(section) > 2 && (
          <LabeledControl
            controlId={FEE_PAYMENT_TIME.THREE_EQUAL_INSTALLMENTS}
            label={<Label>In three consecutive equal installments, beginning upon the lease start date</Label>}
            control={<Radio name="fee-payment-timing" checked={fourthChecked} onChange={onChange} />}
            disabled={fourthFieldDisabled}
          />
        )}
    </FieldSet>
  );
}
